"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermission = void 0;
/**
 * Determines if the current session has the required permission for accessing a specific item.
 *
 * @param session - The current user {@link https://stash.mnemonic.no/projects/PAG/repos/authentication/browse/packages/api/src/%40types/Session.d.ts session}.
 *
 * @param item - The item we check if an user has access to. An item don't have a requiredPermission, it is assumed *all* users have asses.
 * If not, we check if the session.functions contains a function named the value of "requiredPermission".
 */
const hasPermission = (session, item) => !item?.requiredPermission || session?.functions?.some((fn) => fn?.name === item.requiredPermission) || false;
exports.hasPermission = hasPermission;
